<template lang="html">
    <div class="container-fluid p-2 p-lg-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">

                <div class="card agent-member-card-responsive">
                    <div class="card-header">
                        Withdraw List - 
                        <span class="responsive-br"></span>
                        <span style="font-weight: bold;">Total Credit: <span class="badge badge-16 badge-primary">{{agentCommission.commission_amount}}</span>
                        <span class="responsive-br"></span>
                        Last Updated: <span class="badge badge-16 badge-info mt-3">{{agentCommission.last_updated}}</span>
                        </span>  
                    </div>
                    <div class="card-body">
                         <div class="row">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-3">
                                        <b-form-datepicker
                                            v-model="filter.from"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                     <div class="col-md-3 mt-3">
                                        <b-form-datepicker
                                            v-model="filter.to"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-3">
                                        <select v-model="filter.payment_method_id" class="form-control">
                                            <option value="">Select Payment Method</option>
                                            <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-3">
                                        <select v-model="filter.status" class="form-control">
                                            <option value="">Select Status</option>
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                            <option value="failed">Failed</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-3">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sortKey === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.bank }}</td>
                                        <td>{{ data.commission_amount }}</td>
                                        <td>{{ data.transaction_date }}</td>
                                        <td>
                                            <span v-if="data.withdraw_status == 'pending'" class="badge badge-primary">Pending</span>
                                            <span v-else-if="data.withdraw_status == 'completed'" class="badge badge-success">Completed</span>
                                            <span v-else class="badge badge-danger">Failed</span>
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <router-link class="float" to="agent-request-withdraw-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import { BFormDatepicker } from 'bootstrap-vue'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'withdrawList',
        metaInfo: {
            title: "Withdraw List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading,
            BFormDatepicker
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                userName: '',
                status: '',
                dataList: [],
                paymentMethod: [],
                agentCommission: [],
                permissions: '',
                columns: {
                    payment_name: "Payment",
                    amount: "Amount",
                    transaction_date: "Date",
                    status: "Status"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    status: '',
                    payment_method_id: '',
                    from: '',
                    to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                getAgentCommissionAction: 'getAgentCommissionAction',
                agentRequestWithdrawListAction: 'agentRequestWithdrawListAction',
                agentPaymentMethodAction: 'agentPaymentMethodAction',
            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async getPaymentMethod(){
				await this.agentPaymentMethodAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async getAgentCommission(){
				await this.getAgentCommissionAction().then(res => {
					this.agentCommission = res.data
                    console.log(this.agentCommission)
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.agentRequestWithdrawListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'agent-request-withdraw-list', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey,
                                status: this.filter.status,
                                payment_method_id: this.filter.payment_method_id,
                                from: this.filter.from,
                                to: this.filter.to
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'agent-request-withdraw-list', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at',
                        status: '',
                        payment_method_id: '',
                        from: '',
                        to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.id = data.id
                this.userName = data.user_name
                this.status = data.status
            },
            async editStatus() {
                this.isLoading = true
				let option = {
					id: this.id,
					status: this.status
				}
                console.log(this.status)
                if(this.status == 'completed'){
					await this.withdrawStatusCompletedAction({
						...option
					}).then(res => {
						if(res.success == false){
							this.alert = res.message
                        }else{
                            this.id = "",
                            this.status = "",
                            this.userName = "",
                            this.$refs['my-modal'].hide()
                        }
                        this.fetchData()
                        this.isLoading = false;
				    }).catch(err => this.isLoading = true)
                }

                if(this.status == 'failed'){
					await this.withdrawStatusFailedAction({
						...option
					}).then(res => {
						if(res.success == false){
							this.alert = res.message
                        }else{
                            this.id = "",
                            this.status = "",
                            this.userName = "",
                            this.$refs['my-modal'].hide()
                        }
                        this.fetchData()
                        this.isLoading = false;
				    }).catch(err => this.isLoading = true)
                }
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.withdrawDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        async mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.status = this.$route.query.status || ''
            this.filter.payment_method_id = this.$route.query.payment_method_id || ''
            this.filter.from = this.$route.query.from || ''
            this.filter.to = this.$route.query.to || ''
            await this.fetchData()
            await this.getPaymentMethod()
            await this.getAgentCommission()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }

// Show line break only on tablet and mobile
.responsive-br {
    display: none;
}
@media (max-width: 991.98px) {
    .responsive-br {
        display: block;
        width: 100%;
        height: 0;
        margin: 0;
        content: "";
        border: 0;
    }
    .responsive-br::after {
        content: "\A";
        white-space: pre;
        display: block;
    }
}
</style>